import React from "react";
import { makeStyles, withStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";
import Input from "@mui/material/Input";
import Slider from "@mui/material/Slider";
import SpeedIcon from "@mui/icons-material/Speed";
import TimelapseIcon from "@mui/icons-material/Timelapse";
import FormControl from "@mui/material/FormControl";
import Stack from "@mui/material/Stack";
import FormLabel from "@mui/material/FormLabel";
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";

const useStyles = makeStyles()((theme) => ({
  image: {
    height: theme.spacing(5),
  },
  inputRow: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(1),
    alignItems: "center",
  },
  sliderStyle: {
    "& .MuiSlider-markLabel": {
      transform: "translateX(-50%) rotate(25deg)",
      fontSize: "small",
    },
  },
}));

const setInputRangeProps = (maxRange: number) => {
  return {
    step: 1,
    min: 0,
    max: maxRange,
    type: "number",
  };
};

const SlowIcon = withStyles(SpeedIcon, {
  root: {
    transform: "scaleX(-1)",
  },
});

const EnvironmentPollutionConfigSlider: React.FC<{
  onChange: (value: number) => void;
  inputLabel: string;
  value: number;
  maxRange?: number;
  infoTooltip?: string;
  timeIcon?: boolean;
}> = ({ onChange, inputLabel, timeIcon, value, infoTooltip, maxRange = 100 }) => {
  const { classes } = useStyles();

  const { t } = useTranslation();

  const sliderChangeHandler = (event: Event, value: number | number[], _: number) => {
    onChange(value as number);
  };

  const inputChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(Math.max(Math.min(maxRange, +event.target.value), 0));
  };

  return (
    <React.Fragment>
      <FormControl fullWidth>
        <Stack direction="row" spacing={2} alignItems="center">
          <FormLabel>{t(inputLabel)}</FormLabel>
          {infoTooltip != null && (
            <Tooltip title={infoTooltip}>
              <InfoIcon color="action" />
            </Tooltip>
          )}
        </Stack>
        <Stack spacing={2} direction="row" sx={{ mb: 1 }} alignItems="center">
          {timeIcon ? <TimelapseIcon /> : <SlowIcon />}
          <Slider
            value={value}
            valueLabelDisplay="off"
            onChange={sliderChangeHandler}
            min={0}
            max={maxRange}
            className={classes.sliderStyle}
            step={10}
          />
          <SpeedIcon sx={{ opacity: timeIcon === true ? 0 : 1 }} />
          <Input
            inputProps={{ ...setInputRangeProps(maxRange), style: { textAlign: "center" } }}
            value={value}
            onChange={inputChangeHandler}
            sx={(theme) => ({ width: theme.spacing(8) })}
          />
        </Stack>
      </FormControl>
    </React.Fragment>
  );
};

export default EnvironmentPollutionConfigSlider;
